/**
 * Route copy for `src/routes/learning` (keys: `routes.learning.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  learningPatternsPage: {
    learningEnabled: 'Learning enabled.',
    learningDisabled: 'Learning disabled.',
    eraseMyLearningData: 'Erase my learning data',
    allLearnedTrendsAndTheirMemory: 'All learned trends and their memory projection will be permanently deleted. Continue?',
    erase: 'Erase',
    learningDataErased: 'Learning data erased.',
    whatWorksPerPlatform: '🧠 What works per platform',
    trendsConfirmedFromYourResultsHook: 'Trends confirmed from YOUR results — hook, length, format, time — with their lift over your average. Transpose a winning LinkedIn post to the other platforms.',
    enableLearning: 'Enable learning',
    loadingTrends: 'Loading trends…',
    perPlatformLearningWillBeAvailable: 'Per-platform learning will be available soon.',
    couldNotLoadTheTrendsErrormsg: 'Could not load the trends: {{errorMsg}}',
    enableDisableLearningAndEraseThe: ': enable/disable learning and erase the learned data.',
    learningIsDisabledNoNewData: 'Learning is disabled: no new data is analyzed. Enable it so the AI learns from your results (no personal data is kept).',
    noConfirmedTrendForNowKeep: 'No confirmed trend for now. Keep publishing: a trend is only kept with enough evidence (n ≥ 15, reliable confidence interval).',
    deletesAllLearnedTrendsAndTheir: 'Deletes all learned trends and their memory projection (Law 25).',
    ciVV2: ' · CI [{{v}}, {{v2}}]',
    loadingEvidence: 'Loading evidence…',
    noEvidencePostAvailable: 'No evidence post available.',
    view: 'view',
    pin: 'Pin',
    hide: 'Hide',
    enterTheIdOfTheWinning: 'Enter the ID of the winning LinkedIn post.',
    chooseAtLeastOneTargetPlatform: 'Choose at least one target platform.',
    lengthVariantSPreparedAsDrafts: '{{length}} variant(s) prepared as drafts.',
    transposeAWinningLinkedinPost: '♻️ Transpose a winning LinkedIn post',
    rewritesAHighPerformingPostAccording: 'Rewrites a high-performing post according to each target platform\'s confirmed trends — as a draft, never published automatically.',
    linkedinPostId: 'LinkedIn post ID',
    generating: 'Generating…',
    transpose: 'Transpose',
    draftSaved: 'draft saved',
    trendsApplied: 'Trends applied:',
  },
};

export default en;
